import type { ButtonProps } from 'antd';

import AddItemIcon from '@/components/Icons/AddItemIcon';

import { AddButtonStyled } from './styles';

export type Props = Omit<ButtonProps, 'icon'> & {
  appearance?: 'default' | 'filled';
  icon?: ButtonProps['icon'];
};

/**
 * Shared "Add" action button. Renders the standard add icon with no background
 * at rest and a green background on hover. Use for every "Add ..." action so
 * they stay visually consistent across the application.
 */
const AddButton = ({
  appearance = 'default',
  icon,
  children,
  ...props
}: Props) => (
  <AddButtonStyled
    $filled={appearance === 'filled'}
    icon={icon ?? <AddItemIcon />}
    {...props}>
    {children}
  </AddButtonStyled>
);

export default AddButton;
